import axios from 'axios'
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_RESET,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_RESET,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL,
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  USER_PROFILE_REQUEST,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_FAIL
} from '../constants/userConstants'
import { API_URL } from '../apiUrl.js'
import {
  RETURNS_RESET,
  RETURNS_UPDATE_RESET
} from '../constants/posConstants.js'

export const login = (email, password) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_LOGIN_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/users/login`,
      { email, password },
      config
    )

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data
    })

    localStorage.setItem('userInfo', JSON.stringify(data))
  } catch (e) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @param {*} id
 * @returns
 */
// Logout user
export const logout = (id) => (dispatch) => {
  axios.defaults.withCredentials = true

  localStorage.removeItem('userInfo')
  localStorage.removeItem('qrcodeScan')

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    axios.post(`${API_URL}/users/logout`, { id }, config)

    dispatch({ type: USER_LOGOUT })
    dispatch({ type: USER_UPDATE_PROFILE_RESET })
    dispatch({ type: USER_DETAILS_RESET })
    dispatch({ type: RETURNS_RESET })
    dispatch({ type: RETURNS_UPDATE_RESET })
    document.location.href = '/login'
  } catch (err) {
    dispatch({
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

/**
 *
 * @param {*} name
 * @param {*} email
 * @param {*} password
 * @param {*} cid
 * @returns
 */
// Register user
export const register = (name, email, password, cid) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_REGISTER_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/users`,
      { name, email, password, cid },
      config
    )

    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: data
    })

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data
    })

    localStorage.setItem('userInfo', JSON.stringify(data))
  } catch (e) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @param {*} ownerinfo
 * @returns
 */
// Register owner
export const registerOwner = (ownerinfo) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: OWNER_REGISTER_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/register`,
      ownerinfo,
      config
    )

    dispatch({ type: OWNER_REGISTER_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: OWNER_REGISTER_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

/**
 *
 * @param {*} user
 * @returns
 */
// Get user details
export const getUserDetails = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_DETAILS_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/users/${id}`, config)

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @param {*} id
 * @returns
 */
// Get user profile
export const getUserProfile = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_PROFILE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/users/profile/${id}`, config)

    dispatch({
      type: USER_PROFILE_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: USER_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Update user profile
export const updateUserProfile = (user) => async (dispatch) => {
  axios.defaults.withCredentials = true

  const { id } = user

  try {
    dispatch({
      type: USER_UPDATE_PROFILE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/users/profile/${id}`,
      user,
      config
    )

    dispatch({
      type: USER_UPDATE_PROFILE_SUCCESS,
      payload: data
    })

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data
    })

    localStorage.setItem('userInfo', JSON.stringify(data))
  } catch (e) {
    dispatch({
      type: USER_UPDATE_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @returns
 */
// List users
export const listUsers = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_LIST_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/users`, config)

    dispatch({
      type: USER_LIST_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @param {*} user
 * @returns
 */
// Delete user
export const deleteUser = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_DELETE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    await axios.delete(`${API_URL}/users/${id}`, config)

    dispatch({
      type: USER_DELETE_SUCCESS
    })
  } catch (e) {
    dispatch({
      type: USER_DELETE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

/**
 *
 * @param {*} user
 * @returns
 */
// Update user
export const updateUser = (user) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: USER_UPDATE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/users/${user._id}`,
      user,
      config
    )

    dispatch({ type: USER_UPDATE_SUCCESS })

    dispatch({ type: USER_DETAILS_SUCCESS, payload: data })

    dispatch({ type: USER_DETAILS_RESET })
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
    if (message === 'Not authorized, token failed') {
      dispatch(logout())
    }
    dispatch({
      type: USER_UPDATE_FAIL,
      payload: message
    })
  }
}
